import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  TransportMeans,
  TransportMeansSort
} from '../../lib/types/models/transport-means/transport-means'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTransportMeans(
  input: PaginationRequest<never, string, Version, TransportMeansSort> = {}
) {
  if (!input.sort) input.sort = { name: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.transportMeans.getAll.url, null), input))
    .get<PaginationResponse<TransportMeans>>()
}
